var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticStyle:{"width":"100%","height":"100%"},attrs:{"src":"https://mmbiz.qpic.cn/mmbiz_gif/4icPNtgBu6QdqrGbKX0vxvQCFiauGgQYgIFPlia2QuN2mxKRiakiadBDLt4Dic9WZRme8n2l7kl6QJQnLhBRPNwNz4Vw/0?wx_fmt=gif","alt":""}})}
var staticRenderFns = []

export { render, staticRenderFns }